module.exports = typeof templateVars !== 'undefined' && typeof testComponentName !== 'undefined' && testComponentName === 'social-services/static-in-line' && templateVars.config ?
				templateVars.config :
				{
	"animationClose": "transition.slideDownOut",
	"animationCloseDuration": 200,
	"animationOpen": "transition.slideUpIn",
	"animationOpenDuration": 200,
	"links": {
		"ru": [
			{
				"modifier": "facebook",
				"targetBlank": true,
				"url": "https://www.facebook.com/MSKExchange",
				"text": "Facebook"
			},
			{
				"modifier": "vkontakte",
				"targetBlank": true,
				"url": "https://vk.com/moscow_exchange",
				"text": "VKontakte"
			},
			{
				"modifier": "twitter",
				"targetBlank": true,
				"url": "https://twitter.com/moscow_exchange",
				"text": "Twitter"
			},
			{
				"modifier": "instagram",
				"targetBlank": true,
				"url": "https://www.instagram.com/moscow_exchange/",
				"text": "Instagram"
			}
		],
		"en": [
			{
				"modifier": "facebook",
				"targetBlank": true,
				"url": "https://www.facebook.com/MSKExchange",
				"text": "Facebook"
			},
			{
				"modifier": "vkontakte",
				"targetBlank": true,
				"url": "https://vk.com/moscow_exchange",
				"text": "VKontakte"
			},
			{
				"modifier": "twitter",
				"targetBlank": true,
				"url": "https://twitter.com/moscow_exchange",
				"text": "Twitter"
			},
			{
				"modifier": "instagram",
				"targetBlank": true,
				"url": "https://www.instagram.com/moscow_exchange/",
				"text": "Instagram"
			}
		]
	}
};


//////////////////
// WEBPACK FOOTER
// ./temp/components/social-services/.variant/static-in-line/config.yaml
// module id = 118
// module chunks = 0